import axios from 'axios'
import authService from './authService.js'

// Configuración base para las peticiones
const API_BASE_URL = import.meta?.env?.VITE_API_BASE_URL || '/api'

// Crear instancia de axios configurada
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
  }
})

// Interceptor para agregar automáticamente el token de autenticación
apiClient.interceptors.request.use(
  async (config) => {
    // Obtener el token más reciente del localStorage en cada petición
    let token = authService.getToken()
    
    // Si no hay token y no está en modo admin, intentar obtener uno anónimo
    if (!token && !authService.isAdminMode()) {
      console.log('🔄 No hay token, solicitando token anónimo...')
      token = await authService.requestAnonymousToken()
    }
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      const tokenType = authService.isAdminMode() ? 'admin' : 
        (authService.isAnonymousOnly ? (authService.isAnonymousOnly() ? 'anónimo' : 'usuario') : 'usuario')
      console.log(`🔑 Token ${tokenType} agregado a la petición:`, config.method?.toUpperCase(), config.url)
    } else {
      console.log('⚠️ No se pudo obtener token para:', config.method?.toUpperCase(), config.url)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para manejar errores globalmente
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Manejar errores de rate limiting
    if (error.response?.status === 429) {
      console.warn('⚠️ Rate limit alcanzado, esperando antes de retry...')
      return Promise.reject(error)
    }
    
    // Manejar errores de autenticación
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Limpiar tokens inválidos
      authService.removeToken()
      
      // Redirigir según el modo
      if (authService.isAdminMode()) {
        console.log('🔄 Error de autenticación en admin, redirigiendo a login')
        window.location.hash = '#/login'
      }
    }
    
    console.error('API Error:', error.response?.data || error.message)
    return Promise.reject(error)
  }
)

export default apiClient
